import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation/translation.service';

/**
 * TranslationPipe used for getting translations for any label in app, uses TranslationService
 */
@Pipe({
    name: 'translate',
    pure: false
})

export class TranslationPipe implements PipeTransform {

    /**
     * The "constructor"
     * @param {TranslationService} translationService
     */
    constructor(private translationService: TranslationService) {
    }

    /**
     * Transformation from property to translated label. Property could be with parameter
     * @param {string} value - property
     * @returns {any} - translated value
     */
    public transform(value: string): any {
        if (!value) {
            return;
        }
        let arr = (value + '').split('|');
        if (arr.length > 1) {
            let translation = '';
            for (const item of arr) {
                translation += this.translationService.get(item);
            }
            return translation;
        }
        return this.translationService.get(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/translation.pipe.ts